import Vue from 'vue'
import App from './App.vue'
import router from './router'
import alert from './assets/script/alert'

Vue.config.productionTip = false
Vue.prototype.$alert = alert.install

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')